export default __webpack_public_path__ + "static/media/main-header-l@2x.bfd12e8a.png";